import { useGetOne } from 'ra-core';
import { useWatch } from 'react-hook-form';
import type { Vendor } from '../../types';

// Shows the selected vendor's address from the DB as soon as the vendor is picked.
export const VendorAddressPreview = () => {
    const vendorId = useWatch({ name: 'vendor_id' });
    const { data: vendor } = useGetOne<Vendor>('vendors', { id: vendorId }, { enabled: !!vendorId });
    if (!vendorId || !vendor) return null;

    const address = [vendor.address, vendor.city, vendor.state].filter(Boolean).join(', ');
    return (
        <div className="w-full rounded-md border bg-slate-50 px-3 py-2 text-sm">
            <span className="font-semibold">Supplier Address: </span>
            {address || <span className="text-muted-foreground">No address on file for this vendor</span>}
        </div>
    );
};
